import React, { useState, useEffect } from 'react';
import { mezunlar, biyolojiGaleri } from '../../data/mezunYorumlari';
import { FaQuoteLeft } from 'react-icons/fa';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { useTranslation } from 'react-i18next';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

SwiperCore.use([Navigation, Pagination]);

const KARAKTER_SINIRI = 100;

const MezunYorumlari = () => {
  const { t } = useTranslation();
  const [aktifFiltre, setAktifFiltre] = useState('Biyoloji');
  const [acikYorum, setAcikYorum] = useState(null); // Modal için

  const bolumlerKeys = ['biology', 'chemistry', 'mathematics', 'statistics', 'actuarialScience'];
  const bolumler = bolumlerKeys.map(key => t(`home.alumni.departments.${key}`));

  const filtrelenmisMezunlar = mezunlar.filter(mezun => mezun.bolum === aktifFiltre);

  // Modal component
  const Modal = ({ mezun, onClose }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-2xl p-8 max-w-lg w-full relative">
        <button onClick={onClose} className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-2xl">&times;</button>
        <div className="flex flex-col items-center mb-4">
          {mezun.foto && (
            <img src={mezun.foto} alt={mezun.isim} className="w-40 h-40 rounded-full object-contain border-4 border-blue-200 mb-4 bg-white" />
          )}
          <p className="font-bold text-blue-800 text-lg mb-1">{mezun.isim}</p>
          {mezun.kurum && <p className="text-sm text-gray-700 mb-1">{mezun.kurum}</p>}
          <p className="text-sm text-gray-500 mb-2">{mezun.bolum} {t('home.alumni.alumniOf')}</p>
        </div>
        <div className="flex items-start">
          <FaQuoteLeft className="text-blue-200 text-4xl mr-4 flex-shrink-0 mt-2" />
          <p className="text-gray-600 italic">"{mezun.yorum}"</p>
        </div>
      </div>
    </div>
  );

  // Biyoloji için galeri kutusu (slider ile)
  const BiyolojiGaleriSlider = () => (
    <Swiper
      slidesPerView={1}
      spaceBetween={30}
      loop={false}
      pagination={{ clickable: true }}
      navigation={true}
      className="mySwiper"
      breakpoints={{
        1024: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
      }}
    >
      {biyolojiGaleri.map(item => (
        <SwiperSlide key={item.id} className="h-full pb-10">
          <div className="relative group cursor-pointer rounded-xl overflow-hidden shadow-lg bg-white flex flex-col h-full">
            <a href={item.link} target="_blank" rel="noopener noreferrer" className="block relative">
              {/* Video etiketi */}
              <span className="absolute top-2 left-2 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded z-10 select-none">Video</span>
              <img
                src={item.foto}
                alt={item.baslik}
                className="w-full h-56 object-contain bg-white transition duration-300"
              />
              {/* Oynat simgesi HER ZAMAN görünür */}
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <svg className="w-16 h-16 text-white drop-shadow-lg" fill="currentColor" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="12" fill="rgba(0,0,0,0.5)" />
                  <polygon points="10,8 16,12 10,16" fill="white" />
                </svg>
              </div>
              {/* Süre çubuğu efekti */}
              <div className="absolute bottom-0 left-0 w-full h-2 bg-black bg-opacity-20">
                <div className="h-full bg-red-500 bg-opacity-80 animate-pulse w-2/3 rounded-r"></div>
              </div>
            </a>
            <div className="p-2 flex flex-col flex-grow">
              <h3 className="font-bold text-blue-800 text-lg mb-1">{item.baslik}</h3>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );

  return (
    <section className="py-12 md:py-20 bg-gray-50">
      <div className="container mx-auto px-2">
        <div className="flex flex-wrap -mx-2 items-center">
          {/* Sol Taraf: Görsel */}
          <div className="w-full lg:w-1/3 px-1 mb-2 lg:mb-0 flex items-center justify-center">
            <img 
              src="https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/mezuniyet2025.jfif"
              alt="Hacettepe Üniversitesi Mezuniyet Töreni"
              className="rounded-lg border-4 border-white shadow-xl object-cover w-full h-[540px] bg-white m-0"
            />
          </div>
          {/* Sağ Taraf: Yorumlar veya Galeri */}
          <div className="w-full lg:w-2/3 px-2">
              {/* Başlık ve açıklama kutusu */}
              <div className="text-left mb-8 mt-20 lg:pl-20">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">{t('home.alumni.title')}</h2>
                <p className="text-lg text-gray-600">{t('home.alumni.subtitle')}</p>
              </div>

              {/* Filtre Butonları */}
              <div className="flex flex-wrap justify-start gap-2 mb-8 lg:pl-20">
                {bolumler.map(bolum => (
                  <button 
                    key={bolum}
                    onClick={() => setAktifFiltre(bolum)}
                    className={`px-4 py-2 text-sm font-semibold rounded-full transition-all duration-300 ease-in-out ${
                      aktifFiltre === bolum
                        ? 'bg-blue-800 text-white shadow-md'
                        : 'bg-white text-gray-700 hover:bg-blue-100 hover:shadow'
                    }`}>
                    {bolum}
                  </button>
                ))}
              </div>

              {/* Biyoloji için galeri, diğerleri için slider */}
              {aktifFiltre === 'Biyoloji' ? (
                <BiyolojiGaleriSlider />
              ) : (
              <Swiper
                key={aktifFiltre}
                slidesPerView={1}
                spaceBetween={30}
                loop={false}
                pagination={{
                  clickable: true,
                }}
                navigation={true}
                className="mySwiper"
                breakpoints={{
                  1024: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                }}
              >
                  {filtrelenmisMezunlar.map(mezun => {
                    const kisaltildiMi = mezun.yorum.length > KARAKTER_SINIRI;
                    const gosterilecekYorum = kisaltildiMi
                      ? mezun.yorum.slice(0, KARAKTER_SINIRI) + '...'
                      : mezun.yorum;
                    return (
                  <SwiperSlide key={mezun.id} className="h-full pb-10">
                    <div className="bg-white rounded-xl shadow-lg p-6 flex items-start h-full transform hover:scale-105 transition-transform duration-300">
                      <FaQuoteLeft className="text-blue-200 text-4xl mr-4 flex-shrink-0" />
                      <div className="flex-grow flex flex-col">
                            <p className="text-gray-600 italic mb-4 flex-grow">
                              "{gosterilecekYorum}"
                              {kisaltildiMi && (
                                <button
                                  className="ml-2 text-blue-700 underline text-sm hover:text-blue-900"
                                  onClick={() => setAcikYorum(mezun)}
                                >{t('home.alumni.continue')}</button>
                              )}
                            </p>
                            <div className="text-right mt-auto flex items-center justify-end gap-2">
                              {mezun.foto && (
                                <img src={mezun.foto} alt={mezun.isim} className="w-14 h-14 rounded-full object-contain border-2 border-blue-200 bg-white" />
                              )}
                              {/* Mezun kutusunda sadece isim ve bölüm mezunu bilgisi gösterilecek */}
                              <div className="flex flex-col items-end">
                          <p className="font-bold text-blue-800">{mezun.isim}</p>
                                {mezun.kurum && mezun.kurum.trim() !== '' && (
                                  <p className="text-xs text-gray-700">{mezun.kurum}</p>
                                )}
                                {mezun.pozisyon && mezun.pozisyon.trim() !== '' && (
                                  <p className="text-xs text-gray-700">{mezun.pozisyon}</p>
                                )}
                          <p className="text-sm text-gray-500">{mezun.bolum} {t('home.alumni.alumniOf')}</p>
                              </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                    );
                  })}
              </Swiper>
              )}
              {/* Modal */}
              {acikYorum && <Modal mezun={acikYorum} onClose={() => setAcikYorum(null)} />}
            </div>
          </div>
        </div>
    </section>
  );
};

export default MezunYorumlari;